import images from "../images/images";

function GameListSelector({ gameList, locProgress, selectedMode, handleGameClickACB }) {
    return (
      <>
        
        {gameList.map(({ key, label, description }) => {
          const gameData = locProgress?.[selectedMode]?.[key];
          
  
          return (
            <div
              key={key}
              className="modeSelection-gameType"
              data-game={key}
              onClick={() => handleGameClickACB(key)}
            >
              <img
                src={images[key]}
                alt={label}
                className="modeSelection-gameIcon"
              />
              <div className="modeSelection-gameInfo">
                <div 
                className={"global-title"}
                >
                  {label}</div>
                {gameData ? (
                  <div className="global-description played">completed</div>
                ) : (
                  <div className="modeSelection-description">{description}</div>
                )}
              </div>
            </div>
          );
        })}
      </>
    );
  }

export {GameListSelector};